<template>
	<div class='index-article cell-group bottom-cell-group'>
		<div class='cell-item'
		v-for="item in params.list"
		:key="item.id"
		@click="articleDetail(item.id)"
		>
			<div class="cell-item-bd">
				<div class="article-title ">
					{{ item.title }}
				</div>
				<div class="article-time">
					{{ item.ctime }}
				</div>
			</div>
		
			<div class="cell-title-img">
                <el-image  style="width: 100px; height:100px"
                    :src="item.cover" fit="fill"></el-image>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
        params: {
            type: [Object, Array]
        }
    },
	computed: {
		count() {  
			// return (this.jdata.params.list.length > 0)
		}
	},
	methods: {
		articleDetail (articleId) {
			const {href} =  this.$router.resolve({
				name: 'help',
				query: {article_id : articleId}
			})
			window.open(href, '_blank');

			// this.$common.navigateTo('/pages/article/index?id=' + articleId+'&id_type=1')
		}
	}
}
</script>

<style>
.cell-item{
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
    border-bottom: 1px solid #eee;
}
.index-article .cell-title-img{
	width: 100px;
	height: 100px;
}

.article-title {
    width: 500px;
    height: 26px;
    overflow: hidden;
    font-size: 18px;
    font-weight: 700;
    line-height: 26px;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #333;
    margin: 10px 0;
}

.article-time{
    width: 500px;
    height: 24px;
    overflow: hidden;
    box-sizing: border-box;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 14px;
    line-height: 24px;
    color: #999;
}
/* .index-article .article-title{
	font-size: 28upx;
	color: #333;
	width: 100%;
	min-height: 80upx;
	display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
}
.index-article .article-time{
	font-size: 24upx;
	color: #999;
	display: inline-block;
	min-width: 220upx;
	min-height: 32upx;
} */

</style>
